import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS, apiRequest } from '@/lib/api';
import { DashboardType, DASHBOARD_NUMBERS } from '@/config/dashboardWorkflows';

export function useDashboardData(dashboardType: DashboardType) {
  const dashboardNum = DASHBOARD_NUMBERS[dashboardType];

  return useQuery({
    queryKey: ['dashboard', dashboardType],
    queryFn: async () => {
      const response = await apiRequest(
        `${API_ENDPOINTS.TASKS.LIST}?dashboard=${dashboardNum}&archive=false`
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ 
          detail: `Failed to fetch ${dashboardType} tasks` 
        }));
        throw new Error(errorData.detail || `Failed to fetch ${dashboardType} tasks`);
      }

      const data = await response.json();
      return data.results || data;
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}



